import { snakeToCamelCase } from '@/utils/snakeCamelTransform';
import { getItemCategories } from '@app/api/category';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ItemCategory } from './types';

export const GET_ITEMS_CATEGORIES_QUERY = 'GET_ITEMS_CATEGORIES_QUERY';

export function useGetItemsCategoriesQuery(): UseQueryResult<ItemCategory[], Error & AxiosError> {
  return useQuery({
    queryKey: [GET_ITEMS_CATEGORIES_QUERY],
    queryFn: async () => snakeToCamelCase(await getItemCategories()),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}
